import { Route } from '@/Enums/Routes/Route.enum';
import { Navigate } from 'react-router-dom';

interface IProps {
  token: string | undefined;
  authFallback?: Route;
  mainFallback?: Route;
  meLoading?: boolean;
}

const FallbackRoute = ({
  token,
  authFallback = Route.LOGIN,
  mainFallback = Route.REPORTING_DASHBOARD,
  meLoading = false,
}: IProps) => {
  // `mainFallback` is derived from the user's screens, so redirecting before they
  // load sends everyone to the default — which for a Unified Reporting user is the
  // legacy dashboard their nav no longer shows. Wait, then redirect once.
  if (token && meLoading) return null;
  if (token) return <Navigate to={mainFallback} />;
  return <Navigate to={authFallback} />;
};

export default FallbackRoute;
